<template>
  <div class="accordion-with-image">
    <div class="accordion-with-image__header">
      <sc-image v-if="fields && fields.icon" :media="fields.icon" class="icon" />
      <div class="content">
        <sc-text tag="h3" v-if="fields && fields.title" :field="fields.title" />
        <sc-text tag="p" v-if="fields && fields.description" :field="fields.description" />
      </div>
    </div>
    <div class="accordion-with-image__header--mobile">
      <div class="top">
        <sc-image v-if="fields && fields.icon" :media="fields.icon" class="icon" />
        <sc-text tag="h3" v-if="fields && fields.title" :field="fields.title" />
      </div>
      <sc-text tag="p" v-if="fields && fields.description" :field="fields.description" />
    </div>
    <div class="accordion-with-image__container">
      <sc-placeholder name="jss-accordion-with-image-item" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Image, Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Accordion-With-Image',
  components: {
    ScImage: Image,
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
.accordion-with-image {
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.08), 0px 17px 18px 0px rgba(0, 0, 0, 0.08);
  margin-bottom: 6.4rem;

  &__header {
    padding: 4rem;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );
    display: none;

    @include tablet-up {
      display: flex;
    }

    // Only show on Mobile
    &--mobile {
      padding: 1.5rem;
      background: linear-gradient(
        169deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 59, 92, 1) 20%,
        rgba(0, 134, 191, 1) 100%
      );

      @include tablet-up {
        display: none;
      }

      .top {
        display: flex;
        align-items: center;
        margin-bottom: 1.6rem;

        .icon {
          width: 6rem;
          height: auto;
          margin-right: 1.2rem;
        }

        h3 {
          font-size: 2rem;
          line-height: 2.6rem;
          color: $white;
          margin: 0;
        }
      }

      p {
        @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $white);
        margin: 0;
      }
    }

    .icon {
      width: 12rem;
      height: auto;
      margin-right: 2.4rem;
      margin-bottom: 0;
    }

    .content {
      color: $white;
      margin: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        font-size: 2.8rem;
        line-height: 3.5rem;
        color: $white;
        margin-top: 0;
        margin-bottom: 0.8rem;

        &:before {
          display: none;
        }
      }

      p {
        font-size: 1.8rem;
        line-height: 2.6rem;
        margin-top: 0;
      }
    }
  }

  &__container {
    .accordion-with-image__item {
      border-bottom: 0.2rem solid $divider;

      &.open {
        border: none;
      }

      &:last-child {
        border: none;
      }

      &.open {
        div {
          &:first-child {
            &:before {
              transform: translate(3.8rem, -0.7rem) rotate(135deg);
            }
          }
        }
        .accordion-with-image__item--content {
          display: block;
          background: $box-gray;
        }
      }

      &--title {
        display: block;
        width: 100%;
        position: relative;
        padding: 2.4rem 4.5rem 2.4rem 2.4rem;
        cursor: pointer;

        &:before {
          font-weight: 700;
          font-size: 2rem;
          content: '∟';
          transform: translate(3.5rem, -1.67rem) rotate(-45deg);
          color: $blue;
          position: absolute;
          top: 50%;
          right: 5rem;
          pointer-events: none;
        }

        h4 {
          display: inline;
          font-size: 1.8rem;
          line-height: 2.4rem;
          color: $blue;
          margin: 0 1rem 0 0;

          @include tablet-up {
            font-size: 2.8rem;
            line-height: 3.5rem;
            margin: 0 1.6rem 0 0;
          }
        }

        .count {
          @include font-styles('Arial', 1.8rem, 200, normal, 2.4rem, 0, $blue);

          @include tablet-up {
            font-size: 2.8rem;
            line-height: 3.5rem;
          }

          span {
            font-weight: 400;
          }
        }
      }

      &--content {
        padding: 2.4rem 3.2rem 0.9rem 3.2rem;
        display: none;
      }

      &-child {
        &--title {
          @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $gray);
          margin: 0 0 2.4rem 0;

          @include tablet-up {
            font-size: 2rem;
            line-height: 2.6rem;
          }
        }
        &--content {
          margin: -1.8rem 1.5rem 1.2rem 2rem;

          ul {
            margin: 0 0 0 1.5rem !important;

            li {
              margin-bottom: 0.8rem !important;

              &:last-child {
                margin-bottom: 0 !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
